import React, { memo, ReactElement, useEffect } from 'react';
import { useAnimate } from 'react-simple-animate';

import { Icon, Heading } from '@dexma/ui-components';
import {
    StyledSidePanel,
    StyledDivider,
    StyledTitleBarGrid,
    StyledScrollableContent,
    StyledFixedHeader,
} from 'adapter/in/dashboards/components/SidePanel/style';

import gtmIds, { dataId } from 'adapter/in/dashboards/config/gtm';

export type SidePanelPropType = {
    showPanel: boolean;
    onClosePanel: () => void;
    onGoBack?: () => void;
    title?: string;
    header?: ReactElement;
    content?: ReactElement;
};
export const SidePanel = (props: SidePanelPropType): ReactElement => {
    const { showPanel, onClosePanel, title, header, content, onGoBack } = props;
    const { play, style } = useAnimate({
        duration: 0.2,
        start: { right: '-30%', minWidth: 0, visibility: 'hidden' },

        end: { right: 0, minWidth: '420px', visibility: 'visible' },
        easeType: 'cubic-bezier(0.4,0.0,0.2,1)',
    });

    useEffect(() => {
        play(showPanel);
    }, [showPanel]);

    return (
        <StyledSidePanel style={style} data-testid='edit-widget-menu'>
            <Title title={title} onClosePanel={onClosePanel} onGoBack={onGoBack} />
            <StyledDivider />
            {header && <StyledFixedHeader data-testid='edit-widget-header'>{header}</StyledFixedHeader>}
            <StyledScrollableContent>{content && content}</StyledScrollableContent>
        </StyledSidePanel>
    );
};

type TitlePropsType = {
    title?: string;
    onClosePanel: () => void;
    onGoBack?: () => void;
};
const Title = (props: TitlePropsType) => {
    const { title, onClosePanel, onGoBack } = props;
    return (
        <>
            <StyledTitleBarGrid>
                <div className='heading'>
                    {onGoBack && (
                        <Icon
                            data-testid='go-back-icon'
                            data-id={`${dataId}.${gtmIds.addWidget.sidePanel.actions.back}`}
                            name='arrow_left'
                            onClick={onGoBack}
                            className='button-back'
                        />
                    )}
                    {title && <Heading data-testid='heading-title' type='h3' color='gray700' text={title} />}
                </div>
                <div>
                    <Icon
                        className='close-icon'
                        data-id={`${dataId}.${gtmIds.addWidget.sidePanel.actions.close}`}
                        onClick={onClosePanel}
                        name='close'
                    />
                </div>
            </StyledTitleBarGrid>
        </>
    );
};

export default memo(SidePanel);
